import type { ReactNode } from 'react';
import styles from './WizardLayout.module.css';

export type WizardLayoutProps = {
  brand: ReactNode;
  exit: ReactNode;
  stepper: ReactNode;
  title: string;
  lead: string;
  status?: ReactNode;
  actions: ReactNode;
  children: ReactNode;
};

export const WizardLayout = ({
  brand,
  exit,
  stepper,
  title,
  lead,
  status,
  actions,
  children,
}: WizardLayoutProps) => (
  <div className={styles['wizard']}>
    <header className={styles['top']}>
      {brand}
      <div className={styles['exit']}>{exit}</div>
    </header>
    <nav className={styles['stepper']}>{stepper}</nav>
    <main className={styles['body']}>
      <div className={styles['lead']}>
        <h1 className={styles['title']}>{title}</h1>
        <p className={styles['text']}>{lead}</p>
      </div>
      {children}
    </main>
    <footer className={styles['footer']}>
      <div className={styles['status']} role="status">
        {status}
      </div>
      <div className={styles['actions']}>{actions}</div>
    </footer>
  </div>
);
